// Phone validation for KoLV order/booking forms.
// Latvian numbers are the default (8 digits, e.g. 20000000), but international
// numbers (+<country><number>) are also accepted so foreign customers can order.

export function normalizePhone(raw) {
  return String(raw || '').replace(/[\s()\-.]/g, '');
}

export function isValidPhone(raw) {
  const p = normalizePhone(raw);
  if (!p) return false;
  if (p.startsWith('+')) return /^\+\d{8,15}$/.test(p);   // international, e.g. +37120000000
  if (/^00\d{8,13}$/.test(p)) return true;                // 00 + country code + number
  if (/^\d{8}$/.test(p)) return true;                     // Latvian local 8-digit
  return false;
}

export const PHONE_ERROR = 'Ievadi derīgu telefona numuru (piem. 20000000 vai +371 20000000)';
